/**
 * The quiet row of numbers under Home's day strip (D354): five, or six on a team project, each
 * a button to the view it came from. One `.art-stats` row of `ArtStat`: label, big value, one
 * always-rendered detail line. The feed stays the hero; this is not a dashboard.
 */
import { Bell, CircleDollar, Clock, Persons, Pulse, Tray } from '@gravity-ui/icons';
import type { ReactNode } from 'react';

import type { HomeStat } from '../../sharedHome.js';
import { ArtStat } from '../ui/Art.js';

const ICONS: Record<HomeStat['id'], ReactNode> = {
  'needs-you': <Tray />,
  running: <Pulse />,
  done: <Clock />,
  'plan-usage': <Bell />,
  cost: <CircleDollar />,
  team: <Persons />,
};

export function HomeStats({ stats, onOpen }: { stats: readonly HomeStat[]; onOpen: (open: string) => void }) {
  return (
    <section className="art-stats home-stats" aria-label="The numbers" data-home-stats data-count={stats.length}>
      {stats.map((s) => (
        <ArtStat key={s.id} tone={s.tone} motif="rings" icon={ICONS[s.id]} label={s.label} value={s.value} detail={s.detail} needsYou={s.needsYou} onPress={() => onOpen(s.open)} />
      ))}
    </section>
  );
}
